import React from 'react';
const ContentPanel = ({ component: Component, props }) => {
    return (React.createElement("div", { id: "content-panel", className: "content-panel" },
        React.createElement(Component, { ...props })));
};
export { ContentPanel };
